<template>
  <div>
    <div>
      <module-title
        :color="secondaryColor"
        :title="
          ['2444', '4531', '8265'].includes(event.id)
            ? 'Prijavite se na radionice'
            : styles.apply || 'Apply to workshops'
        "
        :class="event.extraModules.ticketing ? 'module-title-card' : 'module-title-card-noTicket'"
      />
    </div>
    <div>
      <div class="title-description mb-32 pl-0">
        {{
          styles.titleDescription ||
            (event.id === '8265'
              ? 'Ovdje možete odabrati jednu ili više radionica na kojima želite sudjelovati.'
              : 'Here you can register for attending one or more workshops at the event.')
        }}
      </div>
    </div>
    <div>
      <div v-for="(w, index) in workshops" :key="w.id" class="mb-32 workshop-card-container">
        <p
          v-if="['952', '2444', '4531', '8265'].includes(event.id) && index === 0"
          style="margin-top: 1rem; font-weight: 700; font-size: 1.7rem; color: rgb(255, 76, 0)"
        >
          PREPORUČENE RADIONICE(prema vašem tipu poslovanja)
        </p>
        <p
          v-if="['952', '2444', '4531', '8265'].includes(event.id) && index === 0"
          style="margin-top: 1rem; font-weight: 700; font-size: 1rem; color: rgb(255, 76, 0)"
        >
          NAPOMENA: Obrazac je potrebno ispuniti samo jednom. U prijavi označite sve radionice i događaje na kojima želite sudjelovati
        </p>
        <p
          v-if="['952', '2444', '4531', '8265'].includes(event.id) && index === customTextIndex"
          style="font-weight: 700; font-size: 1.7rem; color: rgb(255, 76, 0)"
        >
          PRIDRUŽITE NAM SE I NA OSTALIM RADIONICAMA
        </p>
        <workshop-card
          :workshop="w"
          :styles="styles.card"
          :selected="isSelected(w.id)"
          :disabled="isDisabled(w.id)"
          :event-id="event.id"
          :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
          :background-color="getThemeStyle(event.coverImagePrimaryColor, 0.25, 'primary')"
          @click="toggleWorkshop(w.id)"
        />
        <text-field
          v-if="
            (selectedWorkshops.includes('239') && w.id === '239') ||
              (selectedWorkshops.includes('296') && w.id === '296') ||
              (selectedWorkshops.includes('358') && w.id === '358') ||
              (selectedWorkshops.includes('514') && w.id === '514')
          "
          id="OIB"
          v-model.trim="attendee.OIB"
          type="text"
          inputmode="numeric"
          pattern="[0-9]{11}"
          :max-length="11"
          autocomplete="off"
          :error-messages="{
            required: 'Ovo polje je obavezno',
            maxLength: 'OIB mora sadržavati 11 brojeva',
            minLength: 'OIB mora sadržavati 11 brojeva',
          }"
          :validator="$v.attendee.OIB"
          label="Unesite Vaš OIB"
          autofocus
          @input="formatOib"
        />
        <date-field
          v-if="
            (selectedWorkshops.includes('239') && w.id === '239') ||
              (selectedWorkshops.includes('296') && w.id === '296') ||
              (selectedWorkshops.includes('358') && w.id === '358') ||
              (selectedWorkshops.includes('514') && w.id === '514')
          "
          id="birthDate"
          v-model.trim="attendee['Datum rođenja']"
          :error-messages="{ required: 'Ovo polje je obavezno' }"
          :validator="$v.attendee['Datum rođenja']"
          label="Unesite Vaš datum rođenja"
          format="DD.MM.YYYY."
          output-format="DD.MM.YYYY."
          placeholder="dd.mm.gggg."
          manual-input
          locale="hr"
          cancel-text="Odustani"
          ok-text="Potvrdi"
        />
      </div>
    </div>
    <v-snackbar v-if="styles.required" v-model="snackbarOpen">
      <span>{{ styles.snackbarText || (event.id === '8265' ? 'Odaberite barem jednu radionicu.' : 'At least one workshop is required') }}</span>
    </v-snackbar>
    <div class="workshops-actions">
      <main-button
        class="back-btn"
        flat
        :text="event && (event.id === '4531' || event.id === '8265') ? 'Natrag' : styles.goBack || 'Cancel'"
        :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
        @click="$emit('back')"
      />
      <main-button
        v-if="event.extraModules.ticketing"
        class="submit-btn"
        depressed
        text="Place order"
        :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
        @click="submitForm()"
      />
      <main-button
        v-else
        class="submit-btn"
        depressed
        :disabled="disableSubmitButton"
        :text="event && (event.id === '4531' || event.id === '8265') ? 'Podnesi' : styles.submit || 'Submit'"
        :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
        @click="submitForm()"
      />
    </div>
  </div>
</template>

<script>
import ModuleTitle from './../../shared/module-title.vue'
import WorkshopCard from './../../workshops/workshop-card.vue'
import { submitGuard, validateWorkshops } from '../../../utils'
import { sortBy } from 'lodash'
import { maxLength, minLength, requiredIf } from 'vuelidate/lib/validators'

const titlesMap = Object.freeze({
  'Općina, Grad, Županija': [
    '238',
    '242',
    '239',
    '240',
    '241',
    '243',
    '224',
    '225',
    '230',
    '231',
    '223',
    '232',
    '233',
    '235',
    '234',
    '244',
    '245',
  ],
  'Proračunski korisnik': ['229', '243', '224', '225', '230', '231', '235', '239', '244', '245'],
  'Komunalno poduzeće': ['226', '243', '227', '224', '225', '230', '245', '244'],
  'Upravitelj stambenim zgradama': ['228', '227', '224', '225', '230', '245', '244'],
  'Ostalo(privatna poduzeća)': ['227', '224', '225', '230', '245', '244'],
})
const titlesMap24 = Object.freeze({
  'Općina, Grad, Županija': [
    '293',
    '297',
    '296',
    '295',
    '294',
    '274',
    '281',
    '284',
    '285',
    '271',
    '287',
    '289',
    '282',
    '279',
    '291',
    '278',
    '277',
    '286',
    '292',
    '298',
    '299',
  ],
  'Proračunski korisnik': [
    '272',
    '275',
    '271',
    '285',
    '291',
    '278',
    '277',
    '276',
    '286',
    '292',
    '296',
    '298',
    '299',
  ],
  'Komunalno poduzeće': [
    '283',
    '285',
    '291',
    '278',
    '277',
    '273',
    '286',
    '279',
    '289',
    '292',
    '298',
    '299',
  ],
  'Upravitelj stambenim zgradama': ['280', '291', '278', '277', '273', '286', '298', '299'],
  'Ostalo (privatna poduzeća)': ['273', '278', '277', '291', '286', '298', '299'],
})
const titlesMap25 = Object.freeze({
  'Općina, Grad, Županija': [
    '325',
    '347',
    '348',
    '349',
    '346',
    '337',
    '327',
    '333',
    '335',
    '334',
    '343',
    '357',
    '355',
    '350',
    '356',
    '345',
    '336',
    '351',
    '352',
    '340',
    '341',
    '342',
    '358',
    '339',
    '338',
    '353',
    '359',
  ],
  'Proračunski korisnik': [
    '329',
    '330',
    '358',
    '337',
    '338',
    '339',
    '340',
    '341',
    '342',
    '343',
    '357',
    '349',
    '350',
    '355',
    '356',
    '351',
    '352',
    '353',
    '360',
    '359',
  ],
  'Komunalno poduzeće': [
    '360',
    '350',
    '355',
    '356',
    '353',
    '334',
    '338',
    '340',
    '341',
    '342',
    '343',
    '352',
    '357',
    '351',
    '339',
    '358',
    '359',
  ],
  'Upravitelj stambenim zgradama': [
    '331',
    '332',
    '350',
    '355',
    '356',
    '353',
    '338',
    '340',
    '341',
    '342',
    '359',
  ],
  'Ostalo (privatna poduzeća)': ['350', '355', '356', '353', '340', '341', '342', '338', '359'],
})
const titlesMap26 = Object.freeze({
  'Općina, Grad, Županija': [
    '513',
    '536',
    '537',
    '538',
    '535',
    '532',
    '533',
    '534',
    '531',
    '543',
    '546',
    '528',
    '530',
    '539',
    '540',
    '541',
    '522',
    '523',
    '524',
    '525',
    '521',
    '527',
    '529',
    '514',
    '542',
    '544',
    '547',
    '516',
    '515',
    '545',
  ],
  'Proračunski korisnik': [
    '516',
    '538',
    '546',
    '514',
    '542',
    '531',
    '525',
    '521',
    '527',
    '528',
    '529',
    '530',
    '534',
    '540',
    '539',
    '541',
    '547',
    '533',
    '532',
    '535',
    '536',
    '537',
    '543',
    '544',
    '545',
    '515',
    '522',
    '523',
    '524',
    '513',
  ],
  'Komunalno poduzeće': [
    '545',
    '524',
    '528',
    '529',
    '530',
    '531',
    '525',
    '521',
    '527',
    '539',
    '540',
    '541',
    '546',
    '514',
    '515',
    '522',
    '523',
    '532',
    '533',
    '534',
    '535',
    '536',
    '537',
    '538',
    '542',
    '543',
    '544',
    '547',
    '516',
    '513',
  ],
  'Upravitelj stambenim zgradama': [
    '515',
    '531',
    '528',
    '529',
    '530',
    '525',
    '521',
    '527',
    '539',
    '540',
    '541',
    '542',
    '546',
    '543',
    '514',
    '516',
    '522',
    '523',
    '524',
    '532',
    '533',
    '534',
    '535',
    '536',
    '537',
    '538',
    '544',
    '545',
    '547',
    '513',
  ],
  'Ostalo (privatna poduzeća)': [
    '525',
    '521',
    '527',
    '528',
    '529',
    '530',
    '531',
    '515',
    '516',
    '522',
    '523',
    '524',
    '532',
    '533',
    '534',
    '535',
    '536',
    '537',
    '538',
    '539',
    '540',
    '541',
    '542',
    '543',
    '544',
    '545',
    '546',
    '547',
    '514',
    '513',
  ],
})
const recommendedWorkshopCounts26 = Object.freeze({
  'Općina, Grad, Županija': 27,
  'Proračunski korisnik': 17,
  'Komunalno poduzeće': 14,
  'Upravitelj stambenim zgradama': 8,
  'Ostalo (privatna poduzeća)': 7,
})
export default {
  components: {
    ModuleTitle,
    WorkshopCard,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
    attendee: {
      type: Object,
      default: null,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    initialWorkshops: {
      type: Array,
      default: null,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
  },
  validations() {
    return {
      attendee: {
        OIB: {
          required: requiredIf(() =>
            this.selectedWorkshops.some(w => ['239', '296', '358', '514'].includes(w)),
          ),
          maxLength: maxLength(11),
          minLength: minLength(11),
        },
        'Datum rođenja': {
          required: requiredIf(() =>
            this.selectedWorkshops.some(w => ['239', '296', '358', '514'].includes(w)),
          ),
        },
      },
    }
  },
  data() {
    let currentTitlesMap = titlesMap
    if (this.event.id === '2444') {
      currentTitlesMap = titlesMap24
    } else if (this.event.id === '4531') {
      currentTitlesMap = titlesMap25
    } else if( this.event.id === '8265'){
      currentTitlesMap = titlesMap26
    }

    return {
      selectedWorkshops: [...this.selected],
      disabledWorkshops: [],
      snackbarOpen: false,
      disableSubmitButton: false,
      titlesMap: currentTitlesMap,
      customTextIndex: null,
      secondaryColor: '#FF4C00',
      workshops: this.initialWorkshops,
    }
  },
  watch: {
    selected() {
      this.selectedWorkshops = this.selected
    },
  },
  mounted() {
    if (['952', '2444', '4531', '8265'].includes(this.event.id)) {
      const customWorkshopsSort = []
      const workshopOrder = this.titlesMap[this.attendee['Tip korisnika']] || []
      this.customTextIndex =
        this.event.id === '8265'
          ? recommendedWorkshopCounts26[this.attendee['Tip korisnika']] || workshopOrder.length
          : workshopOrder.length

      workshopOrder.forEach(id => {
        const workshop = this.workshops.find(w => w.id === id)
        if (workshop) customWorkshopsSort.push({ ...workshop })
      })
      this.workshops.map(w => {
        if (!customWorkshopsSort.some(workshop => workshop.id === w.id)) {
          customWorkshopsSort.push({ ...w })
        }
      })
      this.workshops = customWorkshopsSort
    } else if (['2687', '2341'].includes(this.event.id)) {
      this.workshops = sortBy(this.workshops, ['id'])
    }
  },
  methods: {
    async submitForm() {
      if (this.styles.required)
        if (this.selectedWorkshops.length === 0) {
          return (this.snackbarOpen = true)
        }
      await submitGuard(this, () => {
        this.disableSubmitButton = true
        this.$emit('submit', this.selectedWorkshops)
      })
    },
    isSelected(id) {
      return this.selectedWorkshops.includes(id)
    },
    isDisabled(id) {
      return this.disabledWorkshops.includes(id)
    },
    validateWorkshopDates(id) {
      const selectedWorkshops = this.workshops.filter(
        w => this.selectedWorkshops.includes(w.id) || (w && w.id === id),
      )
      const rest = this.workshops.filter(w => !this.selectedWorkshops.includes(w.id) && w.id !== id)

      this.disabledWorkshops = validateWorkshops(selectedWorkshops, rest).map(w => w.id)
    },
    toggleWorkshop(id) {
      if (this.disabledWorkshops.includes(id)) {
        return
      }
      const index = this.selectedWorkshops.indexOf(id)
      this.validateWorkshopDates(id)

      if (index !== -1) {
        this.selectedWorkshops.splice(index, 1)
        this.validateWorkshopDates()
      } else {
        this.selectedWorkshops.push(id)
      }
    },
    formatOib(value) {
      this.attendee.OIB = String(value || '')
        .replace(/\D/g, '')
        .slice(0, 11)
    },
  },
}
</script>

<style scoped>
.workshops-actions {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 800px) {
  .workshops-actions {
    flex-direction: column-reverse;
  }
}
</style>
